import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-locale';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import { SERVICE_ACCESSES } from '@adsk/acs-admin-ui-components-helpers';
import { permissionNameStyle, containerStyle } from './styles';

const ProductContent = ({ productType, selectedAccessLevel }) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  let content = T.translate('PERMISSIONS.SEE_DOCS');

  if (productType === PRODUCT_IDS.INSIGHT) {
    if (selectedAccessLevel === SERVICE_ACCESSES.ADMIN) {
      content = (
        <>
          {T.translate('PERMISSIONS.INSIGHT.ALL_DASHBOARDS')}
          <span css={permissionNameStyle}>
            {T.translate('PERMISSIONS.LABELS.MANAGE')}
          </span>
        </>
      );
    } else {
      content = (
        <>
          {T.translate('PERMISSIONS.INSIGHT.CERTAIN_DASHBOARDS')}
          <span css={permissionNameStyle}>
            {T.translate('PERMISSIONS.LABELS.VIEW')}
          </span>
        </>
      );
    }
  }

  return <div css={containerStyle}>{content}</div>;
};

ProductContent.propTypes = {
  productType: PropTypes.string.isRequired,
  selectedAccessLevel: PropTypes.string.isRequired,
};

export default ProductContent;
